export const DEFAULT_POSITION = 'right';
//# sourceMappingURL=Tooltip.constants.js.map